import { create } from 'zustand';
import { immerMiddleware } from '../services/Utils';

export const defaultClient = {
  company: '',
  pan: '',
  gst: '',
  name: '',
  email: '',
  mobile: '',
  addresses: [''],
  banks: [{ bankName: '', bankIfsc: '', bankBranch: '', accountName: '', accountNumber: '', accountType: '' }]
};

const clientsStore = set => ({
  client: defaultClient,
  setClient: client => {
    set(state => {
      state.client = client;
    });
  },
  setId: id => {
    set(state => {
      state.client.id = id;
    });
  },
  setCompany: company => {
    set(state => {
      state.client.company = company;
    });
  },
  setPan: pan => {
    set(state => {
      state.client.pan = pan;
    });
  },
  setGst: gst => {
    set(state => {
      state.client.gst = gst;
    });
  },
  setContactName: contactName => {
    set(state => {
      state.client.name = contactName;
    });
  },
  setContactEmail: contactEmail => {
    set(state => {
      state.client.email = contactEmail;
    });
  },
  setContactMobile: contactMobile => {
    set(state => {
      state.client.mobile = contactMobile;
    });
  },
  setDetails: details => {
    set(state => {
      state.client.details = details;
    });
  },
  addAddress: () => {
    set(state => {
      state.client.addresses.push('');
    });
  },
  updateAddress: (address, index) => {
    set(state => {
      state.client.addresses.splice(index, 1, address);
    });
  },
  deleteAddress: index => {
    set(state => {
      state.client.addresses.splice(index, 1);
    });
  },
  addBank: () => {
    set(state => {
      state.client.banks.push({ bankName: '', bankIfsc: '', bankBranch: '', accountName: '', accountNumber: '', accountType: '' });
    });
  },
  updateBank: (bank, index) => {
    set(state => {
      state.client.banks.splice(index, 1, bank);
    });
  },
  deleteBank: index => {
    set(state => {
      state.client.banks.splice(index, 1);
    });
  }
});

export const useClientsStore = create(immerMiddleware(clientsStore));
